import axios from "axios";
const baseURL = process.env.REACT_APP_API_URL;

// Get Dashboard Data
export const get_dashboard_data = async () => {
    const response = await axios.get(baseURL + "/dashboard_data");
    return response.data;
}

